/**
 * The least a rep may pay now: $1, or the whole deposit when that is less (so a
 * deposit under a dollar stays payable). The server holds the same rule and answers
 * any amount outside it on the amount field (SN-8441 / SN-8442).
 */
export const minimumPaymentCents = (depositCents: number): number =>
  Math.min(100, depositCents)
